"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const react_1 = __importStar(require("react"));
const styles_1 = require("./styles");
const { root: Root } = styles_1.styles;
const icons = {
    check: (react_1.default.createElement("svg", { fill: "none", stroke: "currentColor", strokeWidth: "1.5", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "m4.5 12.75 6 6 9-13.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
    x: (react_1.default.createElement("svg", { fill: "none", stroke: "currentColor", strokeWidth: "1.5", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M6 18 18 6M6 6l12 12", strokeLinecap: "round", strokeLinejoin: "round" }))),
};
const Icon = ({ color, size = 24, use, ...props }) => {
    return (react_1.default.createElement(Root, Object.assign({ color: color, size: size }, props), react_1.cloneElement(icons[use], {
        props: {
            ...icons[use].props,
            role: "img",
        },
    })));
};
exports.Icon = Icon;
